import { View, Text } from "react-native";
import { ColumnModel } from "app/services/api/types/common/models/ColumnModel";
import { useMemo } from "react";
import {
  getColumnWidths,
  calculateTotalFr,
  getColumnStyle,
} from "../utils/columnWidthUtils";

interface TableHeaderProps<T> {
  columns: ColumnModel<T>[];
  showHorizontalHeaderDivider?: boolean;
}

export const TableHeader = <T,>({
  columns,
  showHorizontalHeaderDivider,
}: TableHeaderProps<T>) => {
  const columnWidths = useMemo(() => getColumnWidths(columns), [columns]);
  const totalFr = useMemo(() => calculateTotalFr(columnWidths), [columnWidths]);

  return (
    <View
      className={`pb-9 md:px-10 px-6 pt-9 ${
        showHorizontalHeaderDivider ? "border-b border-gray-200" : ""
      }`}
      style={{
        flexDirection: "row",
        gap: 32,
        minWidth: "100%",
      }}
    >
      {columns.map((column, index) => {
        const width = columnWidths[index] || "1fr";
        const style = getColumnStyle(
          width,
          totalFr,
          columns.length,
          column.minWidth,
        );
        const key = `${column.dataKey?.toString() || column.title}-${index}`;
        return (
          <View key={key} style={style}>
            {column.title ? (
              <Text className="text-xs text-typography-600 font-normal">
                {column.title}
              </Text>
            ) : null}
          </View>
        );
      })}
    </View>
  );
};
